import { MainPanelWrapper } from './MainPanelWrapper'

interface MainPanelItemProps {
  children?: React.ReactNode
}

export const MainPanelItem = ({ children }: MainPanelItemProps) => {
  return <MainPanelWrapper>{children}</MainPanelWrapper>
}
